import { createStyles, Theme } from '@material-ui/core'

export const conceptModifiedFormStyles = (theme: Theme) =>
  createStyles({
    dialogForm: {
      // Eliminar min-height del Toolbar del Form (espacio en blanco debajo del título)
      '& .MuiToolbar-regular': {
        minHeight: '0px !important',
        '@media (min-width: 0px) and (orientation: landscape)': {
          minHeight: '0px !important'
        },
        '@media (min-width: 600px)': {
          minHeight: '0px !important'
        }
      }
    }
  })
